import { AppRoute } from '@agentselly/immodossier-shared';
import { evaluationWidgets } from '~/config/widgets/evaluationWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_DOSSIER_EVALUATION,
  evaluationWidgets,
  true,
);
